import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'free-response',
})

export default class FreeResponse extends Vue {

    // ----------------------------------------------------
    // Properties

    @Prop()
    private content!: any;


    @Prop()
    private showCorrect!: boolean;


    private get userAnswer() {
        const content = this.content;
        const userAnswer = content.userAnswer;
        return userAnswer;
    }

    private get question() {
        const question = this.content.resource;
        return question;
    }

    private get baseQuestions() {
        return this.question.answers;
    }

    // ---------------------------------------------------------------
    // Hooks


    // --------------------------------------------------------------
    // Methods

    private frqUserAnswer() {
        const answerObject = this.baseQuestions[0] || null;
        return answerObject ? answerObject.text : 'N/A';
    }




}
